export const RISK_FIELDS = `
  id
  projectId
  alias
  title
  type
  status
  probability
  severity
  totalScore
  riskOwner
  isEscalated
  isIncludedInCustomerReport
  createdBy
  createdAt
  updatedBy
  updatedAt
`;
